import React, { Fragment, useEffect } from 'react';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import DefaultContain from 'Component/DashboardQeza/Order';

const Order = () => {
    // useEffect(() => {
    //     window.scrollTo(0, 0);
    // }, []);

    return (
        <Fragment>
            <Breadcrumbs parent="Reservasi" title="Daftar Reservasi" />
            <DefaultContain />
        </Fragment>
    );
};
export default Order;